import React from 'react';
import { Empty, EmptyProps } from '@drip/drip-design';

function CoreEmpty(props: EmptyProps) {
  return (
    <Empty
      image="//img30.360buyimg.com/pop/jfs/t1/232884/22/7724/12324/657abf88Fe598fc89/b742016ca0dbbdec.png"
      imageStyle={{ height: '120px' }}
      {...props}
    />
  );
}

export default CoreEmpty;
